import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Запрос ручной перемодерации домена магазина
 */
export const RequestDomainRemoderationContentType = '' as const;
export type RequestDomainRemoderationRequest = void;
export type RequestDomainRemoderationResponses = LinkCommonErrorResponses & {};
export type RequestDomainRemoderationResponseSuccess = undefined;
export type RequestDomainRemoderationSearchParams = undefined;
export type RequestDomainRemoderationPathParameters = undefined;
export const RequestDomainRemoderationUrl = '/store/domain/remoderation' as const;
export const RequestDomainRemoderationMethod = 'POST' as const;
export const getRequestDomainRemoderationUrl = (_params?: RequestDomainRemoderationPathParameters) =>
    RequestDomainRemoderationUrl;
